import { render } from "./PeriodSelector.vue?vue&type=template&id=7618175c"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script